export default {
      id: "pen-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#pen-usage",
      toString: function () {
        return this.url;
      }
    }